export const setFavicon = () => {
    const favicon: any = document.querySelector('link[rel="icon"]');
    if (!favicon) {
      return;
    }
  
    favicon.href = window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'optilift-logo-dark.svg'
      : 'optilift-logo-light.svg';
  };
  